module.exports = __webpack_public_path__ + "img/toilet-paper-under-slash.0443e8b1.svg";